import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import { type CachedAPIResponse } from '../models/CachedAPIResponse';
import { type IAugmentedBackendResponse } from '../models/IAugmentedBackendResponse';
import { type ISortingMeta } from '../models/ISortingMeta';
import { type IOpsNewsLatest } from '../models/OpsNewsResponse';
import { type PlotlyResponse } from '../models/PlotlyModel';
import { type TPandasTable } from '../models/TPandasTable';
import CoreJsonAPIService from './CoreJsonAPIService';

export default class SvOpsNewsServices extends CoreJsonAPIService {
  static async getLatest(params: { factsheetID: string }) {
    return await super.get<CachedAPIResponse<IOpsNewsLatest>>(
      EDjangoAppsEndpoints.opsNews,
      'latest',
      {
        factsheetID: params.factsheetID
      }
    );
  }

  static async getMergers(params: { factsheetID: string; page: number; search: string; sorting: ISortingMeta }) {
    return await super.get<CachedAPIResponse<IAugmentedBackendResponse<TPandasTable>>>(
      EDjangoAppsEndpoints.opsNews,
      'mergers',
      {
        factsheetID: params.factsheetID,
        page: params.page,
        searchText: params.search,
        sortCol: params.sorting.sortCol,
        ascending: params.sorting.ascending
      }
    );
  }

  static async getDividends(params: { factsheetID: string; page: number; search: string; sorting: ISortingMeta }) {
    return await super.get<CachedAPIResponse<IAugmentedBackendResponse<TPandasTable>>>(
      EDjangoAppsEndpoints.opsNews,
      'dividends',
      {
        factsheetID: params.factsheetID,
        page: params.page,
        searchText: params.search,
        sortCol: params.sorting.sortCol,
        ascending: params.sorting.ascending
      }
    );
  }

  static async getTradingPlots(params: { factsheetID: string }) {
    return await super.get<
      CachedAPIResponse<{
        turnover_comparison: PlotlyResponse;
        buy_sell_comparison: PlotlyResponse;
      }>
    >(
      EDjangoAppsEndpoints.opsNews,
      'trading/plots',
      {
        factsheetID: params.factsheetID
      }
    );
  }
}